export function ftName(fn, ln) {
    return `${ [ fn || "", ln || "" ].filter(Boolean).join(" ") }` || "-";
}

export function fRecipientName(fn, ln) {
    return `${ [ fn || "", ln || "" ].filter(Boolean).join(" ") }` || "-";
}
